import { createContext, useContext } from 'react';

export const WhatsAppDrawerContext = createContext(null);

export const useWhatsAppDrawer = () => {
  const context = useContext(WhatsAppDrawerContext);
  if (!context) throw new Error('useWhatsAppDrawer must be used within WhatsAppDrawerProvider');
  return context;
};
